Object.defineProperty(exports,"__esModule",{value:true});var _reactNative=require('react-native');

var ViewPropTypes=_reactNative.ViewPropTypes||_reactNative.View.propTypes;exports.default=

ViewPropTypes;
//# sourceMappingURL=viewPropTypes.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/native-base/dist/src/Utils/viewPropTypes.js
// module id = 461
// module chunks = 0